function goUp(){
    window.scrollTo(0, 0);
};
export default goUp;